module.exports = __webpack_public_path__ + "static/media/teams-scape-no-data.0fe24148.svg";